// axios
import axios from 'axios'
import env from './env.js'

const domain = ""

const instance = axios.create({
  domain,
  baseURL: `${env.domain}/api/admin/`,
  headers: {'X-Requested-With': 'XMLHttpRequest'}
});
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

export default instance
